import { NSSpace, NSSpaceSizeType } from './NSSpace';
import { NSLinkBlue } from './NSLinkBlue';
import { ILinkProps } from '../props/ILinkProps';
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IImageProps } from '../props/IImageProps';
import Styles from './NSCard.module.css'

export interface NSCardProps extends IBaseComponentProps
{
	title?: string;
	headline?: {
		color?: string;
		text: string;
	}
	description?: string;
	image: IImageProps;
	link: ILinkProps;
}

export function NSCard(props: NSCardProps)
{
	return (
		<div
			id={props.id}
			className={`${Styles.ns_card} ${props.classList?.join(" ") ?? ""}`}
			style={props.style}
		>
			<a
				href={props.link.href}
				target={props.link.target ?? "_blank"}
				rel="noreferrer"
				className={Styles.ns_card_detail_container}
			>
				<div className={Styles.ns_card_title_img}>
					<img className={Styles.ns_card_img} alt='Card' {...props.image} />
					{props.headline &&
						<span className={Styles.ns_card_headline} style={{ color: props.headline?.color }}> {props.headline.text} </span>
					}
					<h3 className={Styles.ns_card_title}>
						{props.title}
					</h3>
				</div>
				{
					props.description &&
					<p className={Styles.ns_card_description}>
						{props.description}
					</p>
				}
			</a>
			{
				props.link.title &&
				<div className={Styles.ns_card_link_container}>
					<NSLinkBlue
						title={props.link.title}
						href={props.link.href}
						target={props.link.target ?? "_blank"}
						style={{ marginTop: "24px" }}
					/>
					<NSSpace size={NSSpaceSizeType.SMALL} />
				</div>
			}
		</div >
	);
}